import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './SettingsSection.css';

/**
 * Collapsible settings section.
 * @param {object} props
 * @param {string} props.title
 * @param {React.ReactNode} props.children
 * @param {boolean} props.defaultOpen
 */
export default function SettingsSection({ title, children, defaultOpen = true }) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="settings-section">
            <div className="settings-section-header" onClick={() => setOpen((v) => !v)}>
                {open
                    ? <ExpandMoreIcon sx={{ fontSize: 14 }} />
                    : <ChevronRightIcon sx={{ fontSize: 14 }} />
                }
                {title}
            </div>
            {open && <div className="settings-section-body">{children}</div>}
        </div>
    );
}
